import jsPDF from "jspdf";
import { compositeCardDesign } from "./generateCardDesign";

const DPI = 300;
const MM_PER_INCH = 25.4;

/**
 * Generates a PDF with one page per card.
 * Each page is sized to match the card canvas at 150 DPI.
 *
 * - `cardImageUrl` null  → white 400×400 background with QR only.
 * - `rawQrSettings` null → card image only, no QR overlay.
 */
export async function generateCardsPDF(
  cardIds: string[],
  cardImageUrl: string | null,
  rawQrSettings: any | null,
  sceneName: string,
): Promise<void> {
  let pdf: jsPDF | null = null;

  for (const cardId of cardIds) {
    const canvas = await compositeCardDesign(cardId, cardImageUrl, rawQrSettings);
    const wMM = (canvas.width  / DPI) * MM_PER_INCH;
    const hMM = (canvas.height / DPI) * MM_PER_INCH;

    if (!pdf) {
      pdf = new jsPDF({
        unit: "mm",
        format: [wMM, hMM],
        orientation: wMM >= hMM ? "landscape" : "portrait",
      });
    } else {
      pdf.addPage([wMM, hMM], wMM >= hMM ? "landscape" : "portrait");
    }

    // JPEG at 92% quality — good balance of size vs. fidelity
    pdf.addImage(canvas.toDataURL("image/jpeg", 0.92), "JPEG", 0, 0, wMM, hMM);
  }

  if (pdf) {
    pdf.save(`${sceneName}-cards.pdf`);
  }
}
